var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "13px",
    viewBox: "0 0 39 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-1",
    width: "100%",
    height: "100%",
    patternUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image-2"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image-2",
    width: 8,
    height: 8,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAACKADAAQAAAABAAAACAAAAACVhHtSAAAArklEQVQYGW2PMQ7CMAxFfxzTVC3twMLCxhW4C8fgcJwDiR2JiYmBpVDatEmwIybEl5xE+d8vjjlcjmmIjD4UeEp1s0MXHPq4wCjFjmao5kQguQgg+GSzqY1ckQebmENK8dHiJQSl6Zkb66VrggZVp26Du6+zGYXGDY8gIRQmYNfesF+fczAl4PpegZd2REEBurc8ZFMXY4Bt9ZAZ7ISSJtTy1D+RmqX8xH4H/Q19AAheR0iMgWErAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "6 3.2 4.6 5.7 3.2 5.7 1.8 3.2 1.8 7.1 0 7.1 0 0.1 1.9 0.1 3.9 3.8 5.9 0.1 7.8 0.1 7.8 7.1 6 7.1"
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-4",
    width: "100%",
    height: "100%",
    patternUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image-5"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image-5",
    width: 6,
    height: 8,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAABqADAAQAAAABAAAACAAAAADUoIPEAAAAi0lEQVQIHU2OQQoCMQxFf9JORxwZxI0bj+FdPIJH9BSCW/eu3FbrTJk2NpWCH8IP+XkkdL5fJCSHVym/9PCpR8gdeMULXCkmQQIjisFcAjuYCJVSMRu8C6G03doP1vwLr/6AZxzqgt11AY4SjuMDp/2t0iJQYsLGzBiLNxEBrMN2pwXq9StD+X9W+y82IjNVaU8IDwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.23,1.45 C13.0366667,1.43666667 12.78,1.41666667 12.46,1.39 C12.14,1.36333333 11.8633333,1.35 11.63,1.35 C11.3966667,1.35 11.2466667,1.38333333 11.18,1.45 C11.1133333,1.51666667 11.08,1.6 11.08,1.7 L11.08,2.2 L12.73,2.2 L12.73,3.55 L11.08,3.55 L11.08,7.1 L9.33,7.1 L9.33,3.55 L8.63,3.55 L8.63,2.2 L9.33,2.2 L9.33,1.5 C9.33,1.04666667 9.46666667,0.683333333 9.74,0.41 C10.0133333,0.136666667 10.3766667,0 10.83,0 C11.2366667,0 11.6666667,0.0133333333 12.12,0.04 C12.5733333,0.0666666667 12.9433333,0.0866666667 13.23,0.1 L13.23,1.45 Z",
    id: "path-6"
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-7",
    width: "100%",
    height: "100%",
    patternUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image-8"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image-8",
    width: 6,
    height: 6,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAABqADAAQAAAABAAAABgAAAABrkD2lAAAAc0lEQVQIHWPMv735/5e/bAwf/nAyvPvNBaQ5GL7+ZWdg4Wb+xQAC34CSv/4xgwVBClkEWL4zcDFBJM9+lmF49YsbrIBFiPUbAxvjXwYTvicM4eIXwLr//2cA6fjBwMP8k4EPSMMAIyMDAxNIEGYPTAJEAwC2xilC7KB4PgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.91,5.75 C16.2633333,5.75 16.6633333,5.68333333 17.11,5.55 L17.11,1.8 L18.86,1.8 L18.86,7.1 L17.31,7.1 L17.21,6.6 C16.8966667,6.80666667 16.575,6.95833333 16.245,7.055 C15.915,7.15166667 15.6366667,7.2 15.41,7.2 L14.96,7.2 C14.5066667,7.2 14.1433333,7.06333333 13.87,6.79 C13.5966667,6.51666667 13.46,6.15333333 13.46,5.7 L13.46,1.8 L15.21,1.8 L15.21,5.4 C15.21,5.5 15.2433333,5.58333333 15.31,5.65 C15.3766667,5.71666667 15.46,5.75 15.56,5.75 L15.91,5.75 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-10",
    width: "100%",
    height: "100%",
    patternUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image-11"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image-11",
    width: 6,
    height: 6,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAABqADAAQAAAABAAAABgAAAABrkD2lAAAAc0lEQVQIHWPMv735/5e/bAwf/nAyvPvNBaQ5GL7+ZWdg4Wb+xQAC34CSv/4xgwVBClkEWL4zcDFBJM9+lmF49YsbrIBFiPUbAxvjXwYTvicM4eIXwLr//2cA6fjBwMP8k4EPSMMAIyMDAxNIEGYPTAJEAwC2xilC7KB4PgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.84,3.15 C22.4866667,3.15 22.0866667,3.21666667 21.64,3.35 L21.64,7.1 L19.89,7.1 L19.89,1.8 L21.44,1.8 L21.54,2.3 C21.8533333,2.09333333 22.175,1.94166667 22.505,1.845 C22.835,1.74833333 23.1133333,1.7 23.34,1.7 L23.79,1.7 C24.2433333,1.7 24.6066667,1.83666667 24.88,2.11 C25.1533333,2.38333333 25.29,2.74666667 25.29,3.2 L25.29,7.1 L23.54,7.1 L23.54,3.5 C23.54,3.4 23.5066667,3.31666667 23.44,3.25 C23.3733333,3.18333333 23.29,3.15 23.19,3.15 L22.84,3.15 Z",
    id: "path-12"
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-13",
    width: "100%",
    height: "100%",
    patternUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image-14"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image-14",
    width: 6,
    height: 8,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAABqADAAQAAAABAAAACAAAAADUoIPEAAAAi0lEQVQIHU2OQQoCMQxFf9JORxwZxI0bj+FdPIJH9BSCW/eu3FbrTJk2NpWCH8IP+XkkdL5fJCSHVym/9PCpR8gdeMULXCkmQQIjisFcAjuYCJVSMRu8C6G03doP1vwLr/6AZxzqgt11AY4SjuMDp/2t0iJQYsLGzBiLNxEBrMN2pwXq9StD+X9W+y82IjNVaU8IDwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.97,7.1 L29.87,6.6 C29.5566667,6.80666667 29.235,6.95833333 28.905,7.055 C28.575,7.15166667 28.2966667,7.2 28.07,7.2 L27.62,7.2 C27.1666667,7.2 26.8033333,7.06333333 26.53,6.79 C26.2566667,6.51666667 26.12,6.15333333 26.12,5.7 L26.12,3.4 C26.12,2.9 26.2616667,2.50833333 26.545,2.225 C26.8283333,1.94166667 27.22,1.8 27.72,1.8 L29.77,1.8 L29.77,0.1 L31.52,0.1 L31.52,7.1 L29.97,7.1 Z M28.57,5.75 C28.9233333,5.75 29.3233333,5.68333333 29.77,5.55 L29.77,3.15 L28.27,3.15 C28.0033333,3.15 27.87,3.28333333 27.87,3.55 L27.87,5.4 C27.87,5.5 27.9033333,5.58333333 27.97,5.65 C28.0366667,5.71666667 28.12,5.75 28.22,5.75 L28.57,5.75 Z",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-16",
    width: "100%",
    height: "100%",
    patternUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image-17"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image-17",
    width: 6,
    height: 6,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAABqADAAQAAAABAAAABgAAAABrkD2lAAAAc0lEQVQIHWPMv735/5e/bAwf/nAyvPvNBaQ5GL7+ZWdg4Wb+xQAC34CSv/4xgwVBClkEWL4zcDFBJM9+lmF49YsbrIBFiPUbAxvjXwYTvicM4eIXwLr//2cA6fjBwMP8k4EPSMMAIyMDAxNIEGYPTAJEAwC2xilC7KB4PgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.35,5.7 C33.7033333,5.8 34.77,5.85 35.55,5.85 C35.65,5.85 35.7333333,5.81666667 35.8,5.75 C35.8666667,5.68333333 35.9,5.6 35.9,5.5 L35.9,5.15 L33.75,5.15 C33.2966667,5.15 32.9333333,5.01333333 32.66,4.74 C32.3866667,4.46666667 32.25,4.10333333 32.25,3.65 L32.25,3.3 C32.25,2.84666667 32.3866667,2.48333333 32.66,2.21 C32.9333333,1.93666667 33.2966667,1.8 33.75,1.8 L37.15,1.8 L37.15,3.1 L34.35,3.1 C34.25,3.1 34.1666667,3.13333333 34.1,3.2 C34.0333333,3.26666667 34,3.35 34,3.45 C34,3.55 34.0333333,3.63333333 34.1,3.7 C34.1666667,3.76666667 34.25,3.8 34.35,3.8 L36.15,3.8 C36.6033333,3.8 36.9666667,3.93666667 37.24,4.21 C37.5133333,4.48333333 37.65,4.84666667 37.65,5.3 L37.65,5.7 C37.65,6.15333333 37.5133333,6.51666667 37.24,6.79 C36.9666667,7.06333333 36.6033333,7.2 36.15,7.2 C34.97,7.2 33.7033333,7.13333333 32.35,7 L32.35,5.7 Z",
    id: "path-18"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mfunds",
    transform: "translate(0.600000, 2.900000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#5E5D5D",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#pattern-1)",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#5E5D5D",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#pattern-4)",
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#5E5D5D",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#pattern-7)",
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#5E5D5D",
    xlinkHref: "#path-12"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#pattern-10)",
    xlinkHref: "#path-12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#5E5D5D",
    xlinkHref: "#path-15"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#pattern-13)",
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#5E5D5D",
    xlinkHref: "#path-18"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#pattern-16)",
    xlinkHref: "#path-18"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d5d68e2fc0c4cc62eafea3052785f4f1.svg";
export { ForwardRef as ReactComponent };